import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import {CLineDec} from '../../classes/decorticage/info-decorticage';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ArmaDate, CUtilit, ModalUtilit } from '../../classes/utilit';
import { ArmaRestOrderList } from '../../classes/json-interface';
import { ActivatedRoute, Router } from '@angular/router';
import { AppToolbarService } from '../../components/toolbar/services/app-toolbar.service';
import { CST_TOOLBAR_BTN_EVENT, ToolbarButton } from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import { TabDecorticageComponent, OrderInfo } from 'src/app/components/tab-decorticage/tab-decorticage.component';
import { DataService } from 'src/app/data.service';
import { TranslateService } from '@ngx-translate/core';
import { BackupDec } from 'src/app/classes/decorticage/backup-dec';
import { UtilitAnalysis } from 'src/app/classes/decorticage/Utilits-analysis';
import {CProduct} from '../../classes/decorticage/info-product';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';

const CST_ORDER_INFORMATION = 'OrderInformation';

@Component({
  selector: 'app-decorticage2',
  templateUrl: './decorticage2.component.html',
  styleUrls: ['./decorticage2.component.css']
})
export class Decorticage2Component implements OnInit {

  CLOSE_BTN: ToolbarButton      = { name: 'Fermer',     color: '',        eventName: CST_TOOLBAR_BTN_EVENT.Close};
  SAVE_ORDER_BTN: ToolbarButton = { name: 'Enregistrer commande', color: '', eventName: CST_TOOLBAR_BTN_EVENT.SaveOrder};
  SEND_ORDER_BTN: ToolbarButton = { name: 'Envoyer commande', color: 'accent',  eventName: CST_TOOLBAR_BTN_EVENT.SendOrder};
  HIDE_SHAPE: ToolbarButton     = { name: 'Masquer forme', color: '',        eventName: CST_TOOLBAR_BTN_EVENT.HideShape};

  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    //console.log('dragover');
    evt.preventDefault();
    evt.stopPropagation();
  }

  //Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    //console.log('dragleave');
    evt.preventDefault();
    evt.stopPropagation();
  }

  //Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: DragEvent) {
    console.log('drop event', evt);
    const files = evt.dataTransfer?.files;
    if (!files)
      return;
    if (files.length == 0) {
      return; // Si on drop autre chose qu'un fichier on fait l'execution normal
    }
    // On bloque le traitement par default du navigateur
    evt.preventDefault();
    evt.stopPropagation();

    for (let i = 0 ; i < files.length ; i++)
      this.mTabAnalysis.addFile(files[i]);
  }

  /**
   * Stockage du backup de la page avant de la recharger
   * Permet aussi de confirmer l'actualisation avant de recharger
   * @param event ?
   */
  @HostListener('window:beforeunload', ['$event']) beforeunloadHandler(event: any) {
    sessionStorage.setItem(CST_ORDER_INFORMATION, JSON.stringify(this.dataService.getInfoSteelList()));
    event.returnValue = '-';
  }

  //@HostListener('window:resize', ['$event']) onResize(event) { }

  // Tableau de décorticage
  @ViewChild('TabAnalysis', { static: true }) mTabAnalysis!: TabDecorticageComponent;

  constructor(private mRouter: Router,
              private route: ActivatedRoute,
              private mSnackBar: MatSnackBar,
              public mDialog: MatDialog,
              public mToolbatService: AppToolbarService,
              public dataService: DataService,
              private mTranslate: TranslateService,      // Pour traduire les snackbar
              private mArmaServMethods: ArmaServServerMethods) { }

  ngOnInit(): void {
    this.setToolbarDisposition(false);
    this.mToolbatService.getObservableClick(true).subscribe(next => this.onToolbarItemClick(next));
    // Chargement du décorticage avec le code passé en param de la page web
    this.loadAnalysis(+this.pageAnalysisCode);

    // Configuration du drawer
    if (window.innerWidth < 1000) {
      // Affihage petit
      this.mTabAnalysis.mDrawerShape.disableClose = false;
      this.mTabAnalysis.mDrawerShape.mode = 'over';
      this.mTabAnalysis.mDrawerShape.close();
    } else {
      // Affichage basique
      this.mTabAnalysis.mDrawerShape.mode = 'side';
      this.mTabAnalysis.mDrawerShape.open();
    }
    this.onOpenedChange(this.mTabAnalysis.mDrawerShape.opened);
  }

  private setToolbarDisposition(readOnly: boolean) {
    const start: ToolbarButton[] = [];
    start.push(this.CLOSE_BTN);
    if (!readOnly) {
      start.push(this.SAVE_ORDER_BTN);
      start.push(this.SEND_ORDER_BTN);
    }
    this.mToolbatService.setDisposition({ start: start, end: [this.HIDE_SHAPE] });
  }

  private async onToolbarItemClick(evenName: string) {
    switch (evenName) {
      case CST_TOOLBAR_BTN_EVENT.Close:
        await this.returnToPreviousMenu();
        break;
      case CST_TOOLBAR_BTN_EVENT.HideShape:
        await this.mTabAnalysis.mDrawerShape.toggle();
        break;
      case CST_TOOLBAR_BTN_EVENT.SaveOrder:
        await this.saveAnalysis();
        break;
      case CST_TOOLBAR_BTN_EVENT.SendOrder:
        await this.sendAnalysis();
        break;
    }
  }

  /**
   * Charge une liste d'acier
   * @param codeSteelList code de la liste d'acier
   */
  private loadAnalysis(codeSteelList: number) {
    if (codeSteelList > 0) {
      // Recuperation de la liste d'acier
      const infoSteelList: ArmaRestOrderList|undefined = this.loadInfoSteelList();
      // On verifie que la list d'acier correspond à la page affiché
      if (infoSteelList && +infoSteelList.Code == codeSteelList) {
        // Lock de la toolbar si decorticage en lecture seul
        this.setToolbarDisposition(infoSteelList.CanEdit == 0);
        // On passe la liste d'acier recuperé & on charge le contenu du décorticage
        this.mTabAnalysis.initAnalysis( //TODO: Duplication avec le save steel list :(
          +infoSteelList.Code,
          {
            CustomerRef: infoSteelList.CustomerRef,
            Designation: infoSteelList.Designation,
            NumPlan: infoSteelList.NumPlan,
            UnixDateDelivery: (infoSteelList.DateDelivery < 0) ? undefined : infoSteelList.DateDelivery,
            Various: infoSteelList.Divers,
            IdContact: infoSteelList.IdContact,
            UnixDateCreate: infoSteelList.UnixDateCreate,
            Note: infoSteelList.Note ?? '',
          },
          (infoSteelList.CanEdit == 0),
          true
        );
      } else {
        // Le code de la page ne correspond pas à la list d'acier selectionnée
        CUtilit.showSnackBar(this.mSnackBar, this.mTranslate, 'Commande inconnue', undefined, 2).catch(console.error);
        this.returnToPreviousMenu(true).catch(console.error);
      }
    } else {
      // Le code de la liste d'acier n'est pas passé dans la page
      // Le décorticage n'existe pas sur armaor, alors on crée une liste d'acier vide sans code pour charger la page
      this.mTabAnalysis.initEmptyAnalysis(true);
      //this.mRouter.navigate(['decorticage', 51]); // Set
      //this.returnToPreviousMenu(true);
    }
  }

  /**
   * Charge les infos de la liste d'acier depuis le serive
   * Si rien dans le service (actualisation page)
   * Alors on t'ente de recuperer les informations depuis le sessionStorage
   * @returns la liste d'acier ou undefined si on n'a pas reussi a la recuperer
   */
  private loadInfoSteelList(): ArmaRestOrderList|undefined {
    let infoSteelList = this.dataService.getInfoSteelList(); // Recuperation des information de la steel list passé en param
    if (!infoSteelList) { // Si on n'a pas les information de la steel list
      // Si pas d'information recuperer on tente de lire le stockage local de la page
      const orderInformation = sessionStorage.getItem(CST_ORDER_INFORMATION);

      // 23/08/2021: Enregistrement du undefine en string, ne devrais pas de produire, ajout controle pour eviter de planter sur la suite du code
      if (orderInformation == 'undefined')
        return undefined;

      if (orderInformation) {
        // On enregistre les information de la liste d'acier et on efface les donnée local de la page
        console.log('Order informations recuperated');
        infoSteelList = (JSON.parse(orderInformation) as ArmaRestOrderList);
        this.dataService.setInfoSteelList(infoSteelList); // On replace les information de la steel liste dans le service dans le cas d'un prochain appel de cette fonction
        sessionStorage.removeItem(CST_ORDER_INFORMATION);
      }
    }
    //if (!infoSteelList) throw 'Unable to load analysis information'; // On ne va pas plus loin sans les infos de la liste d'acier
    return infoSteelList;
  }

  private checkAllLineDec(arrayLineDec: CLineDec[]): boolean {
    const arrayShapeAvailable = this.mTabAnalysis.getArrayShapeAvailable();
    const arrayDiameter = this.mTabAnalysis.mGradeManager.GetArrayDiameter();
    if (!arrayShapeAvailable)
      return false;
    let i = arrayLineDec.length - 1;
    while (i >= 0) {
      if (arrayLineDec[i].isEmpty()) {
        // Si vide alors on supprimer la ligne
      } else {
        // On check si la ligne est valide, on ne prend pas en compte les erreur venant du web pour le moment
        if (arrayLineDec[i].isLineValide(false, arrayShapeAvailable, arrayDiameter) != '') {
          // Si la ligne contiens une erreur
          return false;
        }
      }
      i--;
    }
    return true;
  }

  /**
   * Snackbar qui indique le status de l'enregistrement du décorticage
   * @param bSave le deco a reussi a étre sauvegarder
   * @param customMessage ecrire un message personalisé
   */
  private showSnackBarSave(bSave: boolean, customMessage?: string) {
    let promiseResult: Promise<any>;
    if (customMessage)  promiseResult = CUtilit.showSnackBar(this.mSnackBar, this.mTranslate, customMessage, undefined, 7);
    else if (bSave)     promiseResult = CUtilit.showSnackBar(this.mSnackBar, this.mTranslate, 'Commande enregristrée', undefined, 7);
    else                promiseResult = CUtilit.showSnackBar(this.mSnackBar, this.mTranslate, 'Erreur lors de l\'enregistrement', 'Fermer', 7);
    promiseResult.catch(console.error);
  }

  private async saveSteelList(orderInfo: OrderInfo,
                              arrayLineDec: CLineDec[],
                              arrayProduct: CProduct[]): Promise<boolean> {
    let resultSaveAnalysis = false;
    let steelList: ArmaRestOrderList | undefined;
    // On check si la liste d'acier existe sur armaor
    if (+this.pageAnalysisCode <= 0) {
      // Si elle existe pas alors on la crée avant de la sauvegarder
      steelList = await this.mArmaServMethods.getNewSteelList(orderInfo.SiteCode);
      // On maj l'url de la page pour indique le numéro de la liste d'acier
      this.pageAnalysisCode = steelList.Code;
    } else {
      // On recup la liste d'acier depuis le service
      steelList = this.loadInfoSteelList();
      // Si on arive pas a recuperer la liste d'acier, on la recharge depuis le web
      if (!steelList)
        steelList = await this.mArmaServMethods.getSteelList(+this.pageAnalysisCode);
    }

    // On enregistre les infos de la commande dans la liste d'acier
    steelList.CustomerRef = orderInfo.CustomerRef;
    steelList.Designation = orderInfo.Designation;
    steelList.NumPlan = orderInfo.NumPlan;
    steelList.CodeSite = orderInfo.SiteCode ? orderInfo.SiteCode : '';
    steelList.DateDelivery = orderInfo.UnixDateDelivery ? orderInfo.UnixDateDelivery : ArmaDate.CST_DATE_ZERO_ARMAOR;
    steelList.Divers = orderInfo.Various;
    steelList.IdContact = orderInfo.IdContact;
    steelList.Note = orderInfo.Note;

    // Requete pour Sauvegarde sur le server
    const resultSaveSteelList = await this.mArmaServMethods.saveSteelList({
      InfoSteelList: steelList,
      Data: UtilitAnalysis.convertToJsLineDecProduct(arrayLineDec, arrayProduct)
    });
    console.log('Ana error', resultSaveSteelList.Errors);
    if (resultSaveSteelList.Exception) {
      alert(resultSaveSteelList.Exception);
      throw resultSaveSteelList.Exception;
    }
    if (+resultSaveSteelList.Result == 1) {

      // On upload les fichier vers le serveur, apres avoir recuperer l'order code
      await this.mTabAnalysis.uploadFile(this.pageAnalysisCode);

      // Sauvegarde OK
      resultSaveAnalysis = true;
      this.mTabAnalysis.askToSave = false;

      // Comme on a potenrielement affecter des ID sur les ligne lors de la sauvegarde du décorticage.
      // On doit le recharger pour recuperer les dernierre informations
      // On appel la fonction init du tableau de décorticage pour recharger les infos
      try {
        BackupDec.clearAnalysisBackup(); // On vide ce que l'on a stocké dans le sessionstorage car on va reprendre les infos depuis le backend
        await this.mTabAnalysis.initAnalysis(
          +this.pageAnalysisCode,
          {
            CustomerRef: steelList.CustomerRef,
            Designation: steelList.Designation,
            NumPlan: steelList.NumPlan,
            UnixDateDelivery: (steelList.DateDelivery < 0) ? undefined : steelList.DateDelivery,
            Various: steelList.Divers,
            IdContact: steelList.IdContact,
            UnixDateCreate : steelList.UnixDateCreate,
            Note: steelList.Note ?? '',
          },
          (steelList.CanEdit == 0),
          false
        );
      } catch (e) {
        console.error(e);
        // Erreur lors de la recup des infos de la liste d'acier alors on retourne sur la page de commande
        this.returnToPreviousMenu(true);
      }
    }
    this.showSnackBarSave(resultSaveAnalysis);
    return resultSaveAnalysis;
  }

  async sendAnalysis() {
    // Message de confirmation
    if (!await UtilitAnalysis.modalConfirmSendOrder(this.mDialog))
      return;
    // Sauvegarde du décorticage
    if (!await this.saveAnalysis())
      return;
    // Control de la liste d'acier en local avant de l'envoyer
    if (!this.isAnalysisHeaderValidLocaly)
      return await UtilitAnalysis.checkResultSteelListSend(this.mTabAnalysis.steelListValidity, this.mSnackBar, this.mTranslate);
    // Modification du statut du décorticage
    const isSend = await this.mArmaServMethods.setSteelListAsSend(this.pageAnalysisCode);
    // Controle du resultat de la demande de modification de status
    if (!isSend.IsSend)
      return await UtilitAnalysis.checkResultSteelListSend(isSend, this.mSnackBar, this.mTranslate);
    // Retour a la page precedente
    await this.returnToPreviousMenu();
  }

  /**
   * Sauvegarde du décorticage vers le serveur web
   * @returns Une promise qui contiens true si la validation du decorticage est OK
   */
  async saveAnalysis(): Promise<boolean> {
    if (this.mTabAnalysis.isAnalysisLocked)
      return false;
    let resultSaveAnalysis = false;
    this.mTabAnalysis.lockAnalysis = true;  // On bloque les elements de la page
    this.mToolbatService.toolbarLock = true; // On bloque aussi les elem de la toolbar
    // Permet de remonter une erreur si on await l'envoie des données au serveur
    try {
      // Recuperation des lignes du décorticages
      const arrayLineDec = this.mTabAnalysis.getArrayLineDec();
      const arrayProduct = this.mTabAnalysis.getArrayProduct();

      if (!this.checkAllLineDec(arrayLineDec)) {
        this.showSnackBarSave(false, 'Wrong information in the order');
        return false;
      }

      // On recup les infos du contrat
      const orderInfo = this.mTabAnalysis.getOrderInfo();
      // Check des informations du contrat
      /*
      if (!this.CheckOrderInfo(orderInfo)) {
        return false;
      }
       */
      resultSaveAnalysis = await this.saveSteelList(orderInfo, arrayLineDec, arrayProduct);

    } catch (error) {
      console.error(error);
      this.showSnackBarSave(false);
      resultSaveAnalysis = false;
    } finally {
      this.mTabAnalysis.lockAnalysis = false; // On debloque les elements de la page
      this.mToolbatService.toolbarLock = false; // On debloque aussi les elem de la toolbar
    }
    return resultSaveAnalysis;
  }

  closeAnalysis() {
    this.mTabAnalysis.closeAnalysis();
  }

  async returnToPreviousMenu(ignoreSaveCheck: boolean = false) {
    let canClose = true; // Par default on ferme la page
    if (this.mTabAnalysis.askToSave && !ignoreSaveCheck) {
      canClose = false;
      const dialogResult = await ModalUtilit.yesNoCancel(this.mDialog, '', 'Enregistrer la commande ?');
      if (dialogResult != undefined) { // Undefined = cancel, donc ici true ou false
        // On ferme si on a cliquer sur false ou si la sauvegarde a pas eu de soucis
        canClose = !dialogResult || await this.saveAnalysis();
      }
    }
    if (canClose) {
      BackupDec.clearAnalysisBackup(); // Une fois le déco fermer on a plus bessoins de stocker le backup du décorticage
      this.mRouter.navigateByUrl('myorders'); // On retourne sur la pages de selection des commandes
    }
  }

  /**
   * Permet de modifier le nom du btn pour ouverture/fermeture du drawer
   * @param opened true  = drawer ouverte
   *               false = drawer fermé
   */
  onOpenedChange(opened: boolean) {
    this.HIDE_SHAPE.name = (opened ? 'Masquer forme' : 'Afficher forme');
  }

  get isAnalysisHeaderValidLocaly(): boolean {
    return this.mTabAnalysis.isHeaderValid;
  }

  get pageAnalysisCode(): string {
    return this.route.snapshot.params['code'];
  }

  set pageAnalysisCode(code: string) {
    this.mRouter.navigate(['decorticage', code], { replaceUrl: true /*Ne met pas a jour l'historique de navigation*/});
  }
}
